import React from 'react';
import { Hmi } from '../hmi/Hmi';
import { HmiType } from '../hmi/hmi.interface';
// import { APP_ID } from "../../app.config";
import { useSelector } from 'react-redux';
import { selectSandbox } from '../sandbox/sandboxSlice';

export const DirectSignupHmi: React.FC = () => {
  // return <Hmi applicationId={APP_ID as string} hmiType={HmiType.hatDirect} />;

  const sandbox = useSelector(selectSandbox);
  return <Hmi applicationId={sandbox ? 'hatappstaging' : 'hatapp'} hmiType={HmiType.hatDirect} />;
};
